import { getJourneyId } from './journeyId';

/**
 * Attach path-tracing join keys for agent WebSocket payloads (QPN-2110).
 *
 * - journeyId: per-tab UUID (same as X-Journey-Id on HTTP)
 * - executionSessionId: main-app execution-session UUID (DB), when known
 *
 * Keeps existing payload fields intact (e.g. sessionId) for backward compatibility.
 *
 * @param {Record<string, unknown>} payload
 * @param {string|number|null|undefined} executionSessionId
 * @returns {Record<string, unknown>}
 */
export function withForensicWsFields(payload, executionSessionId) {
  const next = {
    ...payload,
    journeyId: getJourneyId(),
  };

  if (executionSessionId == null || executionSessionId === '') {
    return next;
  }

  next.executionSessionId = String(executionSessionId);
  return next;
}
